import { render, staticRenderFns } from "./IprEdit.vue?vue&type=template&id=462a8883"
import script from "./IprEdit.vue?vue&type=script&lang=js"
export * from "./IprEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports